import { Building2, User } from 'lucide-react';

import { ToggleGroup, ToggleGroupItem } from '@/ui/base/toggle-group';

interface NaturezaToggleProps {
  value: 'PF' | 'PJ';
  onChange: (v: 'PF' | 'PJ') => void;
}

/** Toggle PF | PJ do Fechamento Mensal V2 — usado na lista e no detalhe. */
export function NaturezaToggle({ value, onChange }: NaturezaToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => v && onChange(v as 'PF' | 'PJ')}
      aria-label="Natureza do fechamento"
    >
      <ToggleGroupItem value="PF" className="gap-2" aria-label="Pessoa Física">
        <User className="h-4 w-4" aria-hidden="true" />
        PF
      </ToggleGroupItem>
      <ToggleGroupItem value="PJ" className="gap-2" aria-label="Pessoa Jurídica e Cooperativa">
        <Building2 className="h-4 w-4" aria-hidden="true" />
        PJ / Coop.
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
